// extracted by mini-css-extract-plugin
export default {"buttLeft":"ds_kQ","buttRight":"ds_kR","disabled":"ds_fL","nointroButtLeft":"ds_ns","nointroButtRight":"ds_nt"};